/**
 * Format+Parse utils for react-final-form
 * Typically, you want to use the same helper for format and parse
 * so you coerce initial state to a formatted value, too
 * @see https://final-form.org/docs/react-final-form/types/FieldProps#format
 * */

export const MAX_AGE = 150;

export const formatAge = (value) => {
  if (value === undefined || value === null || value === "") {
    return null;
  }
  const numericValue = parseInt(value, 10);
  // Return null for non-numeric or negative values
  if (isNaN(numericValue) || numericValue < 0) {
    return null;
  }
  // Enforce maximum age cap - because we can't quote for ages > 150
  return numericValue > MAX_AGE ? MAX_AGE : numericValue;
};

export const formatCurrencyAsFloat = (value = 0) => {
  if (!isNaN(value)) {
    return value;
  }

  const numericString = value.replace(/[^0-9.]/g, "");
  let number = parseFloat(numericString);

  if (isNaN(number)) {
    number = 0;
  }

  return parseInt(number.toFixed(2), 10);
};
